<p
  data-slot="empty-description"
  class="empty-description"
  [ngClass]="className"
>
  <ng-content></ng-content>
</p>
